// extracted by mini-css-extract-plugin
export default {"star":"Star_star__VZjIw","active":"Star_active__IbulM","hover":"Star_hover__JzHce"};